import { Icons } from '@storebrand-digital/insurance-definitions';
import {
  ContentWrapper,
  InsuranceDetailsContainer,
  InsuranceViewContainer,
  StyledIcon,
} from 'Components/InsuranceDetailsSections/insuranceDetailsSections.styles';
import { Markdown } from 'Components/Markdown';
import { PageContentWrapper } from 'Components/PageContentWrapper';
import { PageHeader } from 'Components/PageHeader';
import React from 'react';
import { getAppText } from 'Utils/text';

const ErgoHealthInsurancePage = (): React.ReactElement => {
  return (
    <PageContentWrapper>
      <InsuranceDetailsContainer>
        <PageHeader currentPage="detailed" pageTitle="Helseforsikring" />
        <InsuranceViewContainer>
          <StyledIcon name={Icons.HEALTH} />
          <ContentWrapper>
            <h4>{getAppText('detailed.ergo.title')}</h4>
            <Markdown>{getAppText('detailed.ergo.description')}</Markdown>
          </ContentWrapper>
          <ContentWrapper>
            <h4>{getAppText('detailed.ergo.use.title')}</h4>
            <Markdown>{getAppText('detailed.ergo.use.description')}</Markdown>
          </ContentWrapper>
          <ContentWrapper>
            <h4>{getAppText('detailed.ergo.document.title')}</h4>
            <Markdown>
              {getAppText('detailed.ergo.document.description')}
            </Markdown>
          </ContentWrapper>
          <ContentWrapper>
            <h4>{getAppText('detailed.ergo.invoice.title')}</h4>
            <p>{getAppText('detailed.ergo.invoice.description')}</p>
          </ContentWrapper>
        </InsuranceViewContainer>
      </InsuranceDetailsContainer>
    </PageContentWrapper>
  );
};

export default ErgoHealthInsurancePage;
